__turbopack_context__.v({
  "blogDetailActionButton": "kqebrG_blogDetailActionButton",
  "blogDetailActionIcon": "kqebrG_blogDetailActionIcon",
  "blogDetailActions": "kqebrG_blogDetailActions",
  "blogDetailArticle": "kqebrG_blogDetailArticle",
  "blogDetailArticleCard": "kqebrG_blogDetailArticleCard",
  "blogDetailArticleInner": "kqebrG_blogDetailArticleInner",
  "blogDetailBackIcon": "kqebrG_blogDetailBackIcon",
  "blogDetailBackLink": "kqebrG_blogDetailBackLink",
  "blogDetailBadge": "kqebrG_blogDetailBadge",
  "blogDetailBadgeRow": "kqebrG_blogDetailBadgeRow",
  "blogDetailHeaderInner": "kqebrG_blogDetailHeaderInner",
  "blogDetailHeaderSection": "kqebrG_blogDetailHeaderSection",
  "blogDetailLead": "kqebrG_blogDetailLead",
  "blogDetailMeta": "kqebrG_blogDetailMeta",
  "blogDetailMetaAuthor": "kqebrG_blogDetailMetaAuthor",
  "blogDetailMetaIcon": "kqebrG_blogDetailMetaIcon",
  "blogDetailMetaItem": "kqebrG_blogDetailMetaItem",
  "blogDetailProse": "kqebrG_blogDetailProse",
  "blogDetailRelatedCard": "kqebrG_blogDetailRelatedCard",
  "blogDetailRelatedCardExcerpt": "kqebrG_blogDetailRelatedCardExcerpt",
  "blogDetailRelatedCardTitle": "kqebrG_blogDetailRelatedCardTitle",
  "blogDetailRelatedGrid": "kqebrG_blogDetailRelatedGrid",
  "blogDetailRelatedInner": "kqebrG_blogDetailRelatedInner",
  "blogDetailRelatedLink": "kqebrG_blogDetailRelatedLink",
  "blogDetailRelatedSection": "kqebrG_blogDetailRelatedSection",
  "blogDetailRelatedTitle": "kqebrG_blogDetailRelatedTitle",
  "blogDetailTitle": "kqebrG_blogDetailTitle",
  "blogsCardBadge": "kqebrG_blogsCardBadge",
  "blogsCardContent": "kqebrG_blogsCardContent",
  "blogsCardDate": "kqebrG_blogsCardDate",
  "blogsCardExcerpt": "kqebrG_blogsCardExcerpt",
  "blogsCardFooter": "kqebrG_blogsCardFooter",
  "blogsCardLink": "kqebrG_blogsCardLink",
  "blogsCardLinkIcon": "kqebrG_blogsCardLinkIcon",
  "blogsCardMeta": "kqebrG_blogsCardMeta",
  "blogsCardRow": "kqebrG_blogsCardRow",
  "blogsCardTitle": "kqebrG_blogsCardTitle",
  "blogsFeaturedCard": "kqebrG_blogsFeaturedCard",
  "blogsHeroInner": "kqebrG_blogsHeroInner",
  "blogsHeroSection": "kqebrG_blogsHeroSection",
  "blogsHeroSubtitle": "kqebrG_blogsHeroSubtitle",
  "blogsHeroTitle": "kqebrG_blogsHeroTitle",
  "blogsListInner": "kqebrG_blogsListInner",
  "blogsListSection": "kqebrG_blogsListSection",
  "blogsLoadMore": "kqebrG_blogsLoadMore",
  "blogsPostCard": "kqebrG_blogsPostCard",
  "blogsPostCategory": "kqebrG_blogsPostCategory",
  "blogsPostDate": "kqebrG_blogsPostDate",
  "blogsPostExcerpt": "kqebrG_blogsPostExcerpt",
  "blogsPostFooter": "kqebrG_blogsPostFooter",
  "blogsPostLink": "kqebrG_blogsPostLink",
  "blogsPostLinkIcon": "kqebrG_blogsPostLinkIcon",
  "blogsPostMeta": "kqebrG_blogsPostMeta",
  "blogsPostTitle": "kqebrG_blogsPostTitle",
  "blogsPostsGrid": "kqebrG_blogsPostsGrid",
  "footer": "kqebrG_footer",
  "footerBottom": "kqebrG_footerBottom",
  "footerBrand": "kqebrG_footerBrand",
  "footerColumn": "kqebrG_footerColumn",
  "footerCopyright": "kqebrG_footerCopyright",
  "footerGrid": "kqebrG_footerGrid",
  "footerHeading": "kqebrG_footerHeading",
  "footerInner": "kqebrG_footerInner",
  "footerLegal": "kqebrG_footerLegal",
  "footerLinks": "kqebrG_footerLinks",
  "footerLogo": "kqebrG_footerLogo",
  "footerLogoImage": "kqebrG_footerLogoImage",
  "footerTagline": "kqebrG_footerTagline",
  "header": "kqebrG_header",
  "headerInner": "kqebrG_headerInner",
  "headerScrolled": "kqebrG_headerScrolled",
  "legalContainer": "kqebrG_legalContainer",
  "legalInner": "kqebrG_legalInner",
  "logoContainer": "kqebrG_logoContainer",
  "logoImage": "kqebrG_logoImage",
  "menuButton": "kqebrG_menuButton",
  "mobileNav": "kqebrG_mobileNav",
  "mobileNavLink": "kqebrG_mobileNavLink",
  "mobileNavList": "kqebrG_mobileNavList",
  "mobileNavOpen": "kqebrG_mobileNavOpen",
  "nav": "kqebrG_nav",
  "navLink": "kqebrG_navLink",
  "v1Page": "kqebrG_v1Page",
});
